module.exports = "<ui-toolbar-panel title=\"Basislayout\">\n  <div layout=\"row\" layout-wrap>\n    <ui-layout-preview ng-repeat=\"item in layoutDefinitions\" class=\"ui-action\" layout-def=\"item\" onselect=\"bl.onLayoutSelected(item.id)\"></ui-layout-preview>\n  </div>\n</ui-toolbar-panel>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/configurator/basicLayout/basicLayout.html
// module id = 431
// module chunks = 0